import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import tippy from 'tippy.js';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

tippy.setDefaultProps({ interactive: true });

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
